// extracted by mini-css-extract-plugin
export var input = "uTaAsKGJOvMmtCsgO2Bz";
export var root = "_r6STfvsad95w5GYf1Tb";
export var root_error = "TpcVYYaUwIDDj35crUQI";
export var textarea = "OcIFRPO_kbQPWurbqkdx";